<template>


  <div>
    <v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
      <v-stepper-step

              step="1"
      >
        In your browser, while connected to the router's network, navigate to your router admin console
      </v-stepper-step>

      <v-stepper-content step="10">
        In most cases it will be on of the following:
        <ul>
          <li>http://192.168.1.1</li>
          <li>http://192.168.0.1</li>
          <li>http://192.168.2.1</li>
          <li>http://192.168.10.1</li>
        </ul>

      </v-stepper-content>


      <v-stepper-step step="2"
      >
        Sign in to the router's console.
      </v-stepper-step>

      <v-stepper-content step="10">
        The default credentials are

        username: admin
        password: admin

      </v-stepper-content>



      <v-stepper-step step="3" >
        On the top menu, Click "Setup" then "Basic setup"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="4" >
       Look for "Static DNS 1" and "Static DNS 2" on the right section and set GameEnable's DNS
      </v-stepper-step>

      <v-stepper-content step="10">
        <dns-ip-list></dns-ip-list>


      </v-stepper-content>

      <v-stepper-step step="5" >
        Look for "Use DNSMasq for DNS" and check the checkbox.
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="6" >
        Click on "Apply Settings"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="7" >
        Your browser will now reboot and will start with the new DNS
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

    </v-stepper>


  </div>

</template>

<style scoped>

  >>> .v-stepper__label {
    color: rgba(0, 0, 0, 0.87)!important;
  }

</style>

<script>


  import dnsIpList from '../../../../components/dnsIpsList'
  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Setup GameEnable's DNS for DD-WRT router",
    name: 'set-router-dns/ddwrt',
    data: ()=>({
      e6:10
    }),
    components: {

      dnsIpList

    },

  };
</script>
